import React from 'react';
import classNames from 'classnames';
import styles from 'assets/jss/material-dashboard-pro-react/components/sidebarStyle';
import { makeStyles } from '@material-ui/core/styles';
import Logo from 'components/Logo/Logo';
import apiConfig from 'utils/api/config';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBrandProps {
	miniEnabled: boolean;
	miniActive: boolean;
	rtlActive: boolean;
	bgColor: types.sidebar.bgColor;
}

const Brand = ({ miniActive, miniEnabled, rtlActive, bgColor }: IBrandProps) => {
	const classes = useStyles();
	const logoClasses = classNames(classes.logo, { [classes.whiteAfter]: bgColor === 'white' });
	const logoMini = classNames(classes.logoMini, {
		[classes.logoMiniRTL]: rtlActive,
		[classes.logoMiniActive]: miniActive && miniEnabled,
	});

	return (
		<div className={logoClasses}>
			<a href={apiConfig.links.businessLink} target="_blank" rel="noopener noreferrer" className={logoMini}>
				<Logo color="white" size="rg" />
			</a>
		</div>
	);
};

export default Brand;
